import React from 'react';
import styles from './LeadsProductCard.module.scss';
import { Category } from '../../../model/leads/leads';
import { formatCurrency } from '../../../utils';
import { Money } from '../../../model/common/money';

interface LeadsProductCardProps{
  subtitle?: string;
  price?: Money;
  capacity: number;
  description: string;
  companyName?: string;
  imageSrc: string;
  categoryNames : Array<Category>;
  productName: string;
}

const LeadsProductCard = ({ subtitle, price, capacity, description, companyName, imageSrc, categoryNames, productName }: Readonly<LeadsProductCardProps>) => {
  return (
    <div className={styles.container}>
      <div>
        <span className={styles.priceTag}> {price?.amount ? `${formatCurrency(price.amount, { showCurrency: false })} NGN` : 'N/A'}</span>
      </div>
      
      <img 
        src={imageSrc} 
        alt={productName}
        className={styles.productImage}
      />
      
      <div className={styles.tags}>
        {categoryNames.map((res, index) => <span key={res.id} className={`${styles.tag} ${styles.astrum}`}>{res.name}</span>)}
        <span className={`${styles.tag} ${styles.kva}`}>{capacity}kVA</span>
      </div>
      
      <h1 className={styles.title}>
         {productName}
      </h1>
      {subtitle && <h1 className={styles.subTitle}>
         {subtitle}
      </h1>}
    </div>
  );
};

export default LeadsProductCard;